import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isString, snakeCase } from 'lodash';
import MediaQuery from 'react-responsive';

import { LocaleService, ContentZonesService, WindowProxy } from '@sm360/widget-commons-core-services';
import { Vehicle, PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { AnalyticsService, MEDIA_QUERIES, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import TradeInDefault from '@sm360/widget-trade-in';

import ListingHeader from 'inventory-listing/components/ListingHeader/ListingHeader.jsx';
import ListingFilters from 'inventory-listing/components/ListingFilters/ListingFilters.jsx';
import ListingPayment from 'inventory-listing/containers/ListingPaymentsFilter/ListingPaymentsFilter.js';
import ListingResults from 'inventory-listing/components/ListingResults/ListingResults.jsx';
import OrderBy from 'inventory-listing/components/OrderBy/OrderBy.jsx';
import EmptyResult from 'inventory-listing/components/ListingUsed/EmptyResults/EmptyResult.jsx';
import ListingFooter from 'inventory-listing/components/ListingUsed/ListingFooter/ListingFooter.jsx';

import ResultVehicles from 'inventory-listing/containers/ResultVehicles/ResultVehicles.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';

import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';
import SORTINGS from 'inventory-listing/constants/sortings.js';

import 'inventory-listing/components/ListingUsed/ListingUsed.scss';

const { PurchaseMethodsValues } = PurchaseMethods;
const { TradeInBarWrapper } = TradeInDefault.components;

/* eslint react/no-unused-prop-types: 1 */
/* eslint react/prop-types: 0 */

class ListingUsed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterOpened: false,
            rotateIcon: false,
            pageNumber: props.pageNumber,
        };

        this.formatProperties = this.formatProperties.bind(this);
        this.mobileFilterClick = this.mobileFilterClick.bind(this);
        this.onFilterClose = this.onFilterClose.bind(this);
        this.loadMoreVehicle = this.loadMoreVehicle.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.createShadowBox = this.createShadowBox.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.isLoading) {
            const requestedPurchaseMethods = PurchaseMethodsValues.CASH | PurchaseMethodsValues.FINANCE;
            nextProps.actions.setVehicles(nextProps.vehicles);
            nextProps.actions.loadVehiclesPayments(nextProps.vehicles, requestedPurchaseMethods, 0, 96);
        }
        if (this.state.pageNumber <= 1 && this.state.pageNumber !== nextProps.pageNumber) {
            this.setState({ pageNumber: nextProps.pageNumber });
        }
    }

    onFilterClose() {
        this.setState({
            filterOpened: false,
        });

        this.handleScroll(false);

        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const shadow = windowProxy.document.getElementById('listing-shadow');
            if (shadow) {
                windowProxy.document.getElementById('listing-shadow').remove();
            }
        }
    }

    formatProperties(props) {
        const properties = { ...props };
        const { colanderGroupSlug } = properties;

        properties.colanderGroupSlug = isString(colanderGroupSlug)
            ? snakeCase(colanderGroupSlug)
            : this.constructor.defaultProps.colanderGroupSlug;

        return properties;
    }

    mobileFilterClick() {
        this.setState(
            {
                filterOpened: true,
            },
            () => {
                this.handleScroll(true);
                this.createShadowBox();
            }
        );
    }

    handleScroll(enable) {
        if (WindowProxy.get()) {
            const htmlElement = document.getElementsByTagName('html')[0];
            const bodyElement = document.body;
            if (enable) {
                bodyElement.className += ' no-sroll';
                htmlElement.className += ' no-sroll';
            } else {
                bodyElement.className = bodyElement.className.replace('no-sroll', '');
                htmlElement.className = htmlElement.className.replace('no-sroll', '');
            }
        }
    }

    loadMoreVehicle() {
        AnalyticsService.gaTrigger(TAGS.LOAD_MORE_BTN(WindowProxy.location().pathname));
        this.setState((oldState) => {
            return {
                rotateIcon: true,
                pageNumber: oldState.pageNumber + 1,
            };
        });
        this.props.loadMore(this.props.pageInfo.endCursor);
    }

    createShadowBox() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const elemDiv = windowProxy.document.createElement('div');
            elemDiv.id = 'listing-shadow';
            windowProxy.document.body.appendChild(elemDiv);
        }
    }

    render() {
        const props = this.formatProperties(this.props);
        const btnLoading = this.state.rotateIcon
            ? 'listing-used-button-loading sr-button-1 loading-more'
            : 'listing-used-button-loading sr-button-1';

        const contentClass = this.state.filterOpened
            ? 'listing-used-inner-content clearfix filterOpen'
            : 'listing-used-inner-content clearfix';

        const loadMoreBlock = props.pageInfo.hasNextPage &&
            !!props.vehicles.length && (
                <button className={btnLoading} onClick={this.loadMoreVehicle}>
                    <icon className="icon-refresh picto-showroom" />
                    {LocaleService.t('LOAD_MORE')}
                </button>
            );

        const czBackgroundImgUrl = ContentZonesService.getContentZone('widget.listing.used', 'background.img');
        this.style = {
            backgroundImage:
                czBackgroundImgUrl && czBackgroundImgUrl.getValue() ? `url(' ${czBackgroundImgUrl.getValue()}')` : '',
        };

        const { colanderList, isLoading, totalCount } = this.props;
        let listingUrl;
        if (colanderList && colanderList.length > 0) {
            colanderList.forEach((colander) => {
                if (colander.slug === this.props.colanderGroupSlug) {
                    colander.colanders.forEach((col) => {
                        if (col.slug === this.props.vehicleCriteria.colanderSlug) {
                            listingUrl = LocaleService.t('FILTERS.URL_FILTER', {
                                slug: col.urlMapping,
                            });
                        }
                    });
                }
            });
        }

        const showResults = totalCount > 0 || isLoading;

        let defaultSort = SORTINGS.DEFAULT.value;
        if (!props.hasMakePriorityEnabled) {
            const contentZoneDefaultSort = ContentZonesService.getContentZone('widget.listing.used', 'default.sort');
            defaultSort = contentZoneDefaultSort && contentZoneDefaultSort.getValue();
        }
        defaultSort = defaultSort || 'PRICE_ASC';

        const instantEstimate = (
            <TradeInBarWrapper isShowroomV2Enabled={this.props.isShowroomV2Enabled} style={{ marginTop: '60px' }} />
        );
        return (
            <div className="listing-used" style={this.style}>
                <ListingHeader title={props.listingH1} colanderGroupSlug={props.colanderGroupSlug} />
                <div className={contentClass}>
                    <div className="listing-used-header-refine">
                        <button onClick={this.mobileFilterClick} className="picto-showroom">
                            {LocaleService.t('BUTTONS.REFINE')}
                        </button>
                    </div>
                    <ListingFilters
                        hasNewInventory={props.hasNewInventory}
                        hasUsedInventory={props.hasUsedInventory}
                        colanders={props.colanders}
                        colanderList={props.colanderList}
                        onFilterClose={this.onFilterClose}
                        updateVehicleCriteria={props.actions.updateVehicleCriteria}
                        colanderGroupSlug={props.colanderGroupSlug}
                        vehicleCount={props.vehicles.length}
                    />
                    <div className="listing-used-car-wrapper">
                        <div className="listing-used-car-search">
                            <ListingPayment hasLease={props.colanderGroupSlug === COLANDER_GROUPS.NEW} />
                            <div className="listing-used-results-infos">
                                <ListingResults
                                    isLoading={isLoading}
                                    listingUrl={listingUrl}
                                    currentCount={totalCount}
                                />
                                <MediaQuery minWidth={MEDIA_QUERIES.DESKTOP.MIN}>
                                    <OrderBy
                                        defaultSort={defaultSort}
                                        allowSortByDefault={props.hasMakePriorityEnabled}
                                    />
                                </MediaQuery>
                            </div>
                            {showResults ? (
                                <div>
                                    <ResultVehicles
                                        colanderGroupSlug={props.colanderGroupSlug}
                                        carfaxKey={props.carfaxKey}
                                        pageNumber={this.state.pageNumber}
                                        isLoading={this.props.isLoading}
                                    />
                                    {loadMoreBlock}
                                    {instantEstimate}
                                </div>
                            ) : (
                                <EmptyResult />
                            )}
                        </div>
                        <ListingFooter colanderGroupSlug={this.props.colanderGroupSlug} />
                    </div>
                </div>
            </div>
        );
    }
}

ListingUsed.defaultProps = {
    vehicles: [],
    carfaxKey: '',
    colanders: [],
    colanderGroupSlug: COLANDER_GROUPS.DEFAULT,
    dealerMake: '',
    hasUsedInventory: false,
    hasNewInventory: false,
    listingH1: LocaleService.t('FIND_USED_CAR'),
};

ListingUsed.propTypes = {
    loadMore: PropTypes.func.isRequired,
    applyFilter: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
    pageInfo: PropTypes.shape({
        endCursor: PropTypes.string,
        hasNextPage: PropTypes.bool,
    }).isRequired,
    actions: PropTypes.shape({
        // eslint-disable-line react/no-unused-prop-types
        setVehicles: PropTypes.func.isRequired,
        loadVehiclesPayments: PropTypes.func.isRequired,
        updateVehicleCriteria: PropTypes.func.isRequired,
    }).isRequired,
    vehicleCriteria: PropTypes.instanceOf(VehicleCriteriaModel).isRequired, // eslint-disable-line react/no-unused-prop-types
    vehicleOrders: PropTypes.shape({
        // eslint-disable-line react/no-unused-prop-types
        vehicleOrderField: PropTypes.string,
        orderDirection: PropTypes.string,
    }).isRequired,
    carfaxKey: PropTypes.string,
    colanderGroupSlug: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    colanders: PropTypes.arrayOf(
        // eslint-disable-line react/no-unused-prop-types
        PropTypes.shape({
            slug: PropTypes.string,
            name: PropTypes.string,
            displayName: PropTypes.string,
            urlMapping: PropTypes.string,
        })
    ),
    colanderList: PropTypes.arrayOf(
        // eslint-disable-line react/no-unused-prop-types
        PropTypes.shape({
            colanders: PropTypes.array,
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    dealerMake: PropTypes.string,
    hasUsedInventory: PropTypes.bool,
    hasNewInventory: PropTypes.bool,
    vdpUrl: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    totalCount: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    vehicles: PropTypes.arrayOf(
        // eslint-disable-line react/no-unused-prop-types
        PropTypes.instanceOf(Vehicle.VehicleModel)
    ),
    isLoading: PropTypes.bool.isRequired,
    listingH1: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    isShowroomV2Enabled: PropTypes.bool,
    hasMakePriorityEnabled: PropTypes.bool.isRequired,
};

ListingUsed.displayName = 'ListingUsed';

export default ListingUsed;



// WEBPACK FOOTER //
// ./client/src/components/ListingUsed/ListingUsed.jsx